import React from 'react';

export const FamilySafety = ({ t }) => {
  return (
    <div className="card border-0 rounded-3 mb-4 text-white" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div className="card-body p-4">
        <h3 className="h6 fw-bold mb-3">{t('dashboard.index.family_safety.title')}</h3>
        <p className="small mb-4">{t('dashboard.index.family_safety.description')}</p>
        <div className="d-flex align-items-center">
          <i className="bi bi-shield-check me-2"></i>
          <span className="small fw-medium">{t('dashboard.index.family_safety.protected_environment')}</span>
        </div>
      </div>
    </div>
  );
};
